module.exports = __webpack_public_path__ + "static/img/4.163d9984.png";